import { TypedFormattedMessageFactory, useTypedIntlFactory } from 'locale/typedIntl';
import { Language } from 'shared/constants';
import enMessages from './en.json';
import esMessages from './es.json';
import frMessages from './fr.json';
import plMessages from './pl.json';

export type NonstandardConvertersMessages = typeof enMessages;

export const messages: Record<Language, NonstandardConvertersMessages> = {
  EN: enMessages,
  ES: esMessages,
  FR: frMessages,
  PL: plMessages,
};

export const useTypedIntl = useTypedIntlFactory<keyof NonstandardConvertersMessages>();
export const TypedFormattedMessage =
  TypedFormattedMessageFactory<keyof NonstandardConvertersMessages>();
export type TypedIntlShape = ReturnType<typeof useTypedIntl>;
